import React from "react";
import {
  FaEye,
  FaEdit,
  FaKey,
  FaShieldAlt,
  FaTrash,
} from "react-icons/fa";

const ROLE_COLORS = {
  0: "bg-red-100 text-red-700",
  1: "bg-purple-100 text-purple-700",
  2: "bg-blue-100 text-blue-700",
  3: "bg-green-100 text-green-700",
  4: "bg-yellow-100 text-yellow-700",
  5: "bg-pink-100 text-pink-700",
  6: "bg-indigo-100 text-indigo-700",
  7: "bg-orange-100 text-orange-700",
  8: "bg-cyan-100 text-cyan-700",
  9: "bg-emerald-100 text-emerald-700",
  10: "bg-lime-100 text-lime-700",
  11: "bg-fuchsia-100 text-fuchsia-700",
  12: "bg-violet-100 text-violet-700",
};

const UserTable = ({
  users,
  roles,
  hubs,
  loading,
  openEditModal,
  openViewDrawer,
  openPermissionDrawer,
  setSelectedUser,
  setShowResetModal,
}) => {

  const getRoleName = (roleId) => {

    const role = roles.find(
      (r) =>
        Number(r.roleId) ===
        Number(roleId)
    );

    return role?.roleName || "-";
  };

  const getHubName = (hubId) => {

    const hub = hubs.find(
      (h) => h._id === hubId
    );

    return (
      hub?.hub_name ||
      hub?.name ||
      "-"
    );
  };

  const handleDelete =
    async (userId) => {

      const confirmDelete =
        window.confirm(
          "Are you sure you want to delete this user?"
        );

      if (!confirmDelete) {
        return;
      }

      try {

        const response =
          await fetch(
            `${process.env.REACT_APP_FORE_APILINK}user/delete-user?_id=${userId}`,
            {
              method: "DELETE",
            }
          );

        const result =
          await response.json();

        if (!response.ok) {
          throw new Error(
            result.message
          );
        }

        window.location.reload();

      } catch (error) {

        alert(error.message);

      }
    };

  const toggleStatus =
    async (user) => {

      try {

        const response =
          await fetch(
            `${process.env.REACT_APP_FORE_BRICKBUCKET}user/toggle-status`,
            {
              method: "PUT",

              headers: {
                "Content-Type":
                  "application/json",
              },

              body: JSON.stringify({
                user_id:
                  user._id,

                is_active:
                  !user.is_active,
              }),
            }
          );

        const result =
          await response.json();

        if (!response.ok) {
          throw new Error(
            result.message
          );
        }

        window.location.reload();

      } catch (error) {

        alert(error.message);

      }
    };

  if (loading) {

    return (

      <div className="rounded-xl bg-white p-10 text-center shadow">

        Loading Users...

      </div>

    );
  }

  return (

    <div className="overflow-hidden rounded-xl bg-white shadow">

      <div className="overflow-x-auto">

        <table className="min-w-full">

          <thead className="bg-gray-100">

            <tr>

              <th className="px-4 py-3 text-left">
                Username
              </th>

              <th className="px-4 py-3 text-left">
                Name
              </th>

              <th className="px-4 py-3 text-left">
                Email
              </th>

              <th className="px-4 py-3 text-left">
                Mobile
              </th>

              <th className="px-4 py-3 text-left">
                Role
              </th>

              <th className="px-4 py-3 text-left">
                Hubs
              </th>

              <th className="px-4 py-3 text-left">
                Status
              </th>

              <th className="px-4 py-3 text-center">
                Actions
              </th>

            </tr>

          </thead>

          <tbody>

            {users.length === 0 ? (

              <tr>

                <td
                  colSpan={8}
                  className="py-10 text-center"
                >
                  No Users Found
                </td>

              </tr>

            ) : (

              users.map((user) => (

                <tr
                  key={user._id}
                  className="border-t hover:bg-gray-50"
                >

                  <td className="px-4 py-3">
                    {user.username}
                  </td>

                  <td className="px-4 py-3">
                    {user.firstName}
                    {" "}
                    {user.lastName}
                  </td>

                  <td className="px-4 py-3">
                    {user.email}
                  </td>

                  <td className="px-4 py-3">
                    {user.mobileNo}
                  </td>

                  <td className="px-4 py-3">

                    <span
                      className={`rounded-full px-3 py-1 text-xs font-medium ${
                        ROLE_COLORS[
                          user.roleId
                        ] ||
                        "bg-gray-100 text-gray-700"
                      }`}
                    >
                      {getRoleName(
                        user.roleId
                      )}
                    </span>

                  </td>

                  <td className="px-4 py-3">

                    <div className="flex flex-wrap gap-1">

                      {user.hubIds
                        ?.slice(0, 3)
                        .map(
                          (hubId) => (
                            <span
                              key={hubId}
                              className="rounded bg-gray-100 px-2 py-1 text-xs"
                            >
                              {getHubName(
                                hubId
                              )}
                            </span>
                          )
                        )}

                      {user.hubIds
                        ?.length >
                        3 && (
                        <span className="text-xs text-gray-500">
                          +
                          {user.hubIds
                            .length -
                            3}
                        </span>
                      )}

                    </div>

                  </td>

                  <td className="px-4 py-3">

                    <button
                      title={user.is_active ? "Deactivate user" : "Activate user"}
                      onClick={() =>
                        toggleStatus(
                          user
                        )
                      }
                      className={`rounded-full px-3 py-1 text-xs font-medium ${
                        user.is_active
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {user.is_active
                        ? "Active"
                        : "Inactive"}
                    </button>

                  </td>

                  <td className="px-4 py-3">

                    <div className="flex items-center justify-center gap-2">

                      <button
                        title="View user"
                        onClick={() =>
                          openViewDrawer(
                            user
                          )
                        }
                        className="rounded bg-green-100 p-2 text-green-700"
                      >
                        <FaEye />
                      </button>

                      <button
                        title="Edit user"
                        onClick={() =>
                          openEditModal(
                            user
                          )
                        }
                        className="rounded bg-blue-100 p-2 text-blue-700"
                      >
                        <FaEdit />
                      </button>

                      <button
                        title="View permissions"
                        onClick={() =>
                          openPermissionDrawer(
                            user
                          )
                        }
                        className="rounded bg-indigo-100 p-2 text-indigo-700"
                      >
                        <FaShieldAlt />
                      </button>

                      <button
                        title="Reset password"
                        onClick={() => {

                          setSelectedUser(
                            user
                          );

                          setShowResetModal(
                            true
                          );

                        }}
                        className="rounded bg-yellow-100 p-2 text-yellow-700"
                      >
                        <FaKey />
                      </button>

                      <button
                        title="Delete user"
                        onClick={() =>
                          handleDelete(
                            user._id
                          )
                        }
                        className="rounded bg-red-100 p-2 text-red-700"
                      >
                        <FaTrash />
                      </button>

                    </div>

                  </td>

                </tr>

              ))
            )}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default UserTable;